import {  createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var DetectDiseaseRes;
export const DetectDiseaseTodo = createAsyncThunk('DetectDisease', async (data) => {
    console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'admin/predict_disease_report',
            data: data,
            headers: { "Content-Type": "application/json",  "Authorization": 'Bearer ' + localStorage.getItem('user_token')}
        })
        return DetectDiseaseRes = res.data
        
    } catch (error) {
        return DetectDiseaseRes = error.response.data
    }
})